export default __webpack_public_path__ + "static/media/Something.6d680a7a.png";